const HEIGHT_MAP = {
  top: 6,
  bottom: 6,
  left: 20,
  right: 20,
}

const WIDTH_MAP = {
  top: 20,
  bottom: 20,
  left: 6,
  right: 6,
}

export function TooltipArrow ({ side }: { side: 'top' | 'bottom' | 'left' | 'right' }) {
  function renderPath () {
    switch (side) {
      case 'top':
        return (
          <path
            d='M10 6C9.52654 6 9.05307 5.81633 8.69183 5.449L5.30012 2.00004C3.77979 0.414974 2.61984 0.00185299 0 5.86504e-05L10 0.000121592L20 0C17.3802 0.00179434 16.2202 0.414916 14.6999 1.99998L11.3082 5.44894C10.9469 5.81627 10.4735 6 10 6Z'
            fill='currentColor'
          />
        )
      case 'bottom':
        return (
          <path
            d='M10 0C10.4735 0 10.9469 0.183669 11.3082 0.551005L14.6999 3.99996C16.2202 5.58503 17.3802 5.99815 20 5.99994L0 6C2.61984 5.99821 3.77979 5.58508 5.30012 4.00002L8.69183 0.551063C9.05307 0.183727 9.52654 0 10 0Z'
            fill='currentColor'
          />
        )
      case 'right':
        return (
          <path
            d='M0 10C0 9.52654 0.183669 9.05307 0.551005 8.69183L3.99996 5.30012C5.58503 3.77979 5.99815 2.61984 5.99994 0L6 20C5.99821 17.3802 5.58508 16.2202 4.00002 14.6999L0.551063 11.3082C0.183727 10.9469 0 10.4735 0 10Z'
            fill='currentColor'
          />
        )
      case 'left':
        return (
          <path
            d='M6 10C6 10.4735 5.81633 10.9469 5.449 11.3082L2.00004 14.6999C0.414974 16.2202 0.00185299 17.3802 5.86504e-05 20L0 0C0.00179434 2.61984 0.414916 3.77979 1.99998 5.30012L5.44894 8.69183C5.81627 9.05307 6 9.52654 6 10Z'
            fill='currentColor'
          />
        )
    }
  }

  return (
    <svg
      className='text-gray-800'
      fill='none'
      height={HEIGHT_MAP[side]}
      viewBox={`0 0 ${WIDTH_MAP[side]} ${HEIGHT_MAP[side]}`}
      width={WIDTH_MAP[side]}
      xmlns='http://www.w3.org/2000/svg'
    >
      {renderPath()}
    </svg>
  )
}
